export default {
  path: 'feishu_notify_event',
  name: 'feishuNotifyEvent',
  component: () => import('@/pages/feishu_talk/FeiShuEventList'),
  meta: { title: '飞书通知' }
}
